var React = require('react');

function CloseMenuInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"id":"svg_1","strokeLinecap":"round","strokeWidth":"1.5","stroke":"#0DB876","y2":"18.6265","x2":"18.62655","y1":"8.3735","x1":"8.37345","key":0}),React.createElement("line",{"id":"svg_2","strokeLinecap":"round","strokeWidth":"1.5","stroke":"#0DB876","y2":"8.37345","x2":"18.62655","y1":"18.62655","x1":"8.37345","key":1})]);
}

CloseMenuInline.defaultProps = {"width":"27","height":"27"};

module.exports = CloseMenuInline;

CloseMenuInline.default = CloseMenuInline;
